import {
  Box,
  Button,
  Flex,
  Grid,
  GridItem,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import React from "react";
import expedia from "../Images/expedia.png";
import IE from "../Images/Screenshot 2023-06-14 171410.png";
import sanvel from "../Images/sanvel.png";
import { Link } from "react-router-dom";
import immoratl_yoga from "../Images/Screenshot 2023-06-03 184844.png";

const projects = [
  {
    id: 1,
    title: "Immortal Yoga",
    image: immoratl_yoga,
    desc: "  This is the place where you can embark on a transformative journey towards holistic well-being and inner harmony. Our platform is dedicated to promoting physical fitness, mental clarity, and spiritual growth through the practice of yoga",
    tech_stack: [
      "React",
      "Chakra-ui",
      "Fire Base",
      "CSS",
      "HTMl",
      "JavaScript",
    ],
    collaborative: true,
    deployed_link: "https://gleaming-cobbler-bec2a7.netlify.app/",
    repositery_link:
      "https://github.com/aslammmahetar/nosy-silk-95/tree/main/millie",
  },
  {
    id: 2,
    title: "SanVel",
    image: expedia,
    collaborative: false,
    desc: "SanVel tarvel, The clone of travel agency's website called Expedia. Which is provide the facilities of hotel bookings, Flight booking, cab booking and different different packeges to travel",
    tech_stack: [
      "React",
      "Chakra-ui",
      "Fire Base",
      "CSS",
      "HTMl",
      "JavaScript",
    ],
    deployed_link: "https://64297a5acaa5da0ae3e9cbf6--sanvel.netlify.app/",
    repositery_link: "https://github.com/aslammmahetar/regular-shelf-9741",
  },

  {
    id: 3,
    title: "San Shop",
    image: sanvel,
    collaborative: false,
    desc: "It is an clone the one of E-commerce called ShopClues.com. Which is sales a various number of products like mobile accessories, groceries and many more thing",
    tech_stack: ["HTMl", "CSS", "Javascript"],
    deployed_link: "https://peaceful-melba-f238ef.netlify.app/",
    repositery_link: "https://github.com/aslammmahetar/supreme-mouth-2356",
  },
  {
    id: 4,
    title: "Indian Eagle",
    image: IE,
    collaborative: true,
    tech_stack: ["Bootstarp", "HTMl", "CSS", "JavaScript"],
    desc: "It is a clone of an E-Commerce website called americanEagle.com, which is generally sells apparel products like (shirts, jeans, trousers, etc) for both the genders.",
    deployed_link: "https://remarkable-starlight-9a785a.netlify.app/",
    repositery_link: "https://github.com/ritesh22201/spicy-nerve-9354",
  },
];

function OtherProject() {
  return (
    <Box mt={"5"}>
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(1, 1fr)",
          md: "repeat(2, 1fr)",
          lg: "repeat(3, 1fr)",
          xl: "repeat(3, 1fr)",
          "2xl": "repeat(3, 1fr)",
        }}
        gap={"6"}
      >
        {projects.map((el, inde) => {
          return (
            <GridItem
              className="project-card"
              key={inde}
              borderRadius={"10"}
              boxShadow={
                "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
              }
            >
              <Image src={el.image} w={"80%"} m={"auto"} />
              <Box p={"4"}>
                <Heading
                  as={"h3"}
                  mb={"3"}
                  size={"md"}
                  className="project-title"
                >
                  {el.title}
                </Heading>
                <Text w={"100%"} className="project-description">
                  {el.desc}
                </Text>
                <Grid
                  //   border={"solid black"}
                  templateColumns={"repeat(3, 1fr)"}
                  gap={"3"}
                  mt={"5"}
                  mb={"5"}
                  className="project-tech-stack"
                >
                  {el.tech_stack.map((el, ind) => {
                    return (
                      <GridItem m={"auto"} key={ind}>
                        <Button borderRadius={"10"} bgColor={"teal.200"}>
                          {el}
                        </Button>
                      </GridItem>
                    );
                  })}
                </Grid>
                <Box display={"flex"} justifyContent={"center"}>
                  <Flex mt={"5"}>
                    <Link target="_blank" to={el.repositery_link}>
                      <Button
                        cursor={"pointer"}
                        pl={"5"}
                        pr={"5"}
                        borderRadius={"8"}
                        colorScheme="blue"
                        fontWeight={"bold"}
                        fontStyle={"oblique"}
                        className="project-github-link"
                      >
                        GitHub 🧑‍💻
                      </Button>
                    </Link>
                    <Link target="_blank" to={el.deployed_link}>
                      <Button
                        ml={"5"}
                        p={"2"}
                        pl={"5"}
                        pr={"5"}
                        borderRadius={"8"}
                        fontSize={"md"}
                        fontWeight={"bold"}
                        fontStyle={"oblique"}
                        className="project-deployed-link"
                      >
                        Depoloyment 🔗
                      </Button>
                    </Link>
                    <Button
                      ml={"5"}
                      colorScheme={el.collaborative ? "green" : "red"}
                    >
                      {el.collaborative ? "Collaborative 🤝" : "Solo 🧑‍💻"}
                    </Button>
                  </Flex>
                </Box>
              </Box>
            </GridItem>
          );
        })}
      </Grid>
    </Box>
  );
}

export default OtherProject;
